import React from 'react';
import c from 'classnames';

import { MediaPlayer, CookieWrapper } from '@uncinc/uncinc-react-kitchen-sink';

import { getYoutubeIdFromUrl } from '../../helpers';

import './style.scss';

const VideoPlayer = ({ title, url, isModal, autoPlay = true }) => {
  if (!url) {
    return null;
  }

  const youtubeId = getYoutubeIdFromUrl(url);

  if (!youtubeId) {
    return null;
  }

  const onVideoEnded = () => {
    const event = document.createEvent('Event');
    event.initEvent('video-ended', true, true);
    document.dispatchEvent(event);
  };

  const videoClasses = c('video--inner-wrapper', {
    'video--inner-wrapper--modal': isModal,
  });

  return (
    <div className="video--wrapper">
      <div className={videoClasses}>
        <CookieWrapper url={url}>
          <MediaPlayer
            className="VideoPlayer"
            src={url}
            title={title}
            type="video/youtube"
            onEnded={onVideoEnded}
            autoPlay={autoPlay}
          />
        </CookieWrapper>
      </div>
    </div>
  );
};

export default VideoPlayer;
